import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getDitchBrandsData(context) {
      const response = await Vue.axios.get(`${URL_API}ditchbrand`);
      let data = response["data"];
      context.commit("updateDitchBrandsData", data);
    },
    async createDitchBrandData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}ditchbrand/store`, body, config);
      context.dispatch("getDitchBrandsData");
    },
    async pushDitchBrandData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}ditchbrand/update`, body, config);
      context.dispatch("getDitchBrandsData");
    },
    async destroyDitchBrandData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}ditchbrand/destroy`, body, config);
      context.dispatch("getDitchBrandsData");
    }
  },
  mutations: {
    updateDitchBrandsData(state, ditchBrandsData) {
      state.ditchBrandsData = ditchBrandsData;
    }
  },
  state: {
    ditchBrandsData: []
  },
  getters: {
    allDitchBrandsData(state) {
      return state.ditchBrandsData;
    }
  }
};